
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise/overview/skills",
      function () {
        return require("private-next-pages/enterprise/overview/skills.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise/overview/skills"])
      });
    }
  